import { addDays, makeIsoDate } from './date';
/**
 * Easter Sunday in the Gregorian calendar.
 *
 * Six of the nine nationwide German public holidays move with Easter, so this
 * one function fixes most of the year. The algorithm is the Gaussian Easter
 * computation in the Meeus/Jones/Butcher form; it is exact for the Gregorian
 * calendar and needs no lookup table.
 *
 * Deliberately not a hard-coded list of dates: a table would silently run out
 * and start reporting wrong holidays a few years from now.
 */
export function easterSunday(year) {
    if (!Number.isInteger(year) || year < 1583) {
        // Before the Gregorian reform the computation does not apply. No plan in
        // this tool reaches back there, so refusing is safer than guessing.
        throw new Error(`Easter is only computed for Gregorian years: ${year}`);
    }
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    return makeIsoDate(year, month, day);
}
/** Offsets of the movable feasts, counted in days from Easter Sunday. */
export const EASTER_OFFSETS = {
    karfreitag: -2,
    ostersonntag: 0,
    ostermontag: 1,
    christiHimmelfahrt: 39,
    pfingstsonntag: 49,
    pfingstmontag: 50,
    fronleichnam: 60,
};
export function movableFeast(feast, year) {
    return addDays(easterSunday(year), EASTER_OFFSETS[feast]);
}
//# sourceMappingURL=easter.js.map